import { Injectable } from "@angular/core";
// biome-ignore lint/style/useImportType: Router and NavigationEnd are used at runtime
import { NavigationEnd, Router } from "@angular/router";

import { filter } from "rxjs/operators";

@Injectable({ providedIn: "root" })
/**
 * Service to track navigation history and provide access to previous URL.
 */
export class NavigationService {
  private previousUrl: string | undefined = undefined;
  private currentUrl: string | undefined = undefined;

  /**
   * Creates an instance of NavigationService and subscribes to router events.
   * @param {Router} router - Angular router service
   */
  constructor(private router: Router) {
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.previousUrl = this.currentUrl;
        this.currentUrl = event.urlAfterRedirects;
      });
  }

  /**
   * Gets the previous URL before the current navigation.
   * @returns {string | undefined} The previous URL or undefined if no previous navigation exists
   */
  getPreviousUrl(): string | undefined {
    return this.previousUrl;
  }
}
